<template>
  <b-container fluid>
    <b-card
      border-variant="danger"
      :header="$t('EditFilterTags.header')"
      header-bg-variant="danger"
      header-text-variant="white"
      align="left"
    >
      <div>
        <b-tabs content-class="mt-3" v-model="tabIndex">
          <b-tab v-for="(lang, i) in langOptions" :key="i">
            <template v-slot:title>
              <country-flag :country="getLocale(lang)" size="normal" />
            </template>
          </b-tab>
        </b-tabs>
      </div>
      <b-form>
        <b-row class="my-1">
          <b-col>
            <b-form-select :options="dropDownList" required v-model="form.filterTag"></b-form-select>
          </b-col>
        </b-row>
        <b-row class="mt-3" align-v="end">
          <b-col>
            <b-button
              :disabled="disabledBtn"
              variant="info"
              @click="editFilterTag"
            >{{ $t('EditFilterTags.edit') }}</b-button>
            <b-button
              :disabled="disabledBtn"
              variant="danger"
              @click="showModal"
            >{{ $t('EditFilterTags.delete') }}</b-button>
          </b-col>
          <b-col>
            <b-button
              variant="info"
              class="float-right"
              @click="addFilterTag"
            >{{ $t('EditFilterTags.add') }}</b-button>
          </b-col>
        </b-row>
        <b-row class="mt-3 justify-content-center">
          <b-alert
            :show="error.received"
            variant="danger"
            class="text-center"
            dismissible
          >{{error.msg}}</b-alert>
          <b-alert
            :show="success.received"
            variant="success"
            class="text-center"
            dismissible
          >{{success.msg}}</b-alert>
        </b-row>
      </b-form>
    </b-card>
    <!-- DELETE MODAL -->
    <b-modal ref="deleteModalRef" hide-footer header-bg-variant="danger">
      <div class="d-block text-center">
        <h4>{{ $t('EditFilterTags.modalConfirmation') }}</h4>
        <h3 v-if="selectedFilterTag">{{selectedFilterTag.name}}</h3>
      </div>
      <b-btn class="mt-3" cancel @click="hideModal">{{ $t('EditFilterTags.modalCancel') }}</b-btn>
      <b-btn
        class="mt-3"
        ok
        variant="danger"
        @click="deleteFilterTag"
      >{{ $t('EditFilterTags.modalDelete') }}</b-btn>
    </b-modal>
  </b-container>
</template>

<script>
/* CONTROLLER */
import locales from '../i18n/locales'
import FilterTagsService from '@/services/FilterTagsService'

export default {
  name: 'EditFilterTags',
  data () {
    return {
      filterTags: [],
      filterTagName: [],
      dropDownList: [{
        value: null,
        text: this.$i18n.t('EditFilterTags.dropDownText')
      }],
      error: {
        received: false,
        msg: ''
      },
      form: {
        filterTag: null
      },
      langOptions: [],
      selectedFilterTag: null,
      selectedLanguage: this.$i18n.locale,
      success: {
        received: false,
        msg: ''
      },
      tabIndex: 0,
      unfilteredFilterTags: []
    }
  },
  mounted () {
    // redirect if user not logged in
    let smartdineLocalStorage = JSON.parse(window.localStorage.getItem('smartdine'))

    if (!smartdineLocalStorage.token) this.$router.push({ name: 'Login' })

    // else, get filter tags and available languages
    else {
      this.getFilterTags()
      this.languageOptions()
      this.selectedLanguage = this.langOptions[this.tabIndex].value
    }
  },
  methods: {
    async getFilterTags () {
      const response = await FilterTagsService.getFilterTags()
      this.unfilteredFilterTags = response.data.filtertags
      this.filterFilterTags()
    },
    filterFilterTags () {
      // clear out filterTags array if not empty
      if (this.filterTags.length > 0) {
        this.filterTags = []
      }

      // filter based on current language
      // and assign to filterTags
      this.unfilteredFilterTags.forEach((filtertag) => {
        let localeFilterTag = {
          _id: filtertag._id,
          name: this.filterLang(filtertag)
        }
        this.filterTags.push(localeFilterTag)
      })

      // clear out if list bigger than 1 item
      if (this.dropDownList.length > 1) {
        this.dropDownList = []
        this.dropDownList.push({ text: this.$i18n.t('EditFilterTags.dropDownText'), value: null })
      }

      // populate drop-down list
      this.filterTags.forEach(filtertag => {
        let dplFT = {
          text: filtertag.name,
          value: filtertag._id
        }

        this.dropDownList.push(dplFT)
      })
    },
    getFilterTag () {
      this.selectedFilterTag = this.filterTags.find(ft => {
        return ft._id === this.form.filterTag
      })
    },
    editFilterTag () {
      this.getFilterTag()

      // set currentFilterTag state
      let currentFT = this.unfilteredFilterTags.filter(ft => {
        return ft._id === this.selectedFilterTag._id
      })[0]
      this.$store.dispatch('setCurrentFilterTag', currentFT)

      this.$router.push({ name: 'EditFilterTag', params: { filtertag: this.selectedFilterTag._id } })
    },
    addFilterTag () {
      this.$router.push({ name: 'AddFilterTag' })
    },
    showModal () {
      this.getFilterTag()
      this.$refs.deleteModalRef.show()
    },
    hideModal () {
      this.$refs.deleteModalRef.hide()
    },
    async deleteFilterTag () {
      try {
        const response = await FilterTagsService.deleteFilterTag({ _id: this.selectedFilterTag._id })
        const deletedFT = response.data.filtertag

        // build success message
        this.success.received = true
        this.success.msg = `${this.filterLang(deletedFT)} ${this.$i18n.t('EditFilterTags.serverMessages.deletedMessage')}`
      } catch (error) {
        this.error.received = true
        this.error.msg = error.response.data.error
      }
      // take out filtertag from drop-down list and reset form
      this.dropDownList = this.dropDownList.filter(filtertag => filtertag.value !== this.selectedFilterTag._id)
      this.form.filterTag = null

      this.hideModal()
    },
    languageOptions () {
      // get languages from i18n and assign value/text to langOptions
      this.langOptions = Object.keys(this.$i18n.messages).map(l => {
        return { value: l, text: l.toUpperCase() }
      })
    },
    filterLang (filtertag) {
      // filter for selected language
      let text = filtertag.name.filter(t => { return t.lang === this.selectedLanguage })

      // if text value undefined, filter for and assing a defined value
      text = (text.length > 0) ? text[0].value : filtertag.name.filter(t => { return t.value.length > 0 })[0].value
      return text
    },
    getLocale (lang) {
      return locales.filter(l => l.code === lang.value)[0].flag
    }
  },
  computed: {
    disabledBtn () {
      if (this.form.filterTag === null) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    tabIndex () {
      if (this.tabIndex !== -1) {
        this.selectedLanguage = this.langOptions[this.tabIndex].value
        this.filterFilterTags()
      }
    },
    selectedFilterTag () {
      this.filterTagName = this.selectedFilterTag.name[0].value
    }
  }
}
</script>

<style scoped>
  .btn {
    margin: 0.1em 0.25em 0.1em 0.25em;
  }

  .modal-dialog h3 {
    color: #0d47a1;
  }
</style>



// WEBPACK FOOTER //
// src/components/EditFilterTags.vue